import { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import _ from 'lodash';
import './textEntry.scss';

const TextEntry = (props) => {
  const inputRef = useRef(null);

  let defaultValue = _.get(props.stateData, props.entry.mapTo) || '';

  let [ , updateValue] = useState(defaultValue);

  
  let myChangeHandler = (event) => {
    let mapTo = event.target.name;
    let val = event.target.value;
    updateValue(val);
    props.onChangeHandler(mapTo, val);
  };

  const formatPhoneNumber = (e) => {
    if (e.target.value && e.target.value.length > 0) {
      const x = e.target.value.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
      if (_.isArray(x)) {
        e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + '-' + x[3];
        updateValue(e.target.value);
        props.onChangeHandler(e.target.name, e.target.value);
      }
    }
  };

  const formatSocialSecurityNumber = (e) => {
    if (e.target.value && e.target.value.length > 0) {
      const x = e.target.value.replace(/\D/g, '').match(/(\d{3})(\d{2})(\d{4})/);
      if (_.isArray(x)) {
        e.target.value = !x[2] ? x[1] : '' + x[1] + '-' + x[2] + '-' + x[3];
        updateValue(e.target.value);
        props.onChangeHandler(e.target.name, e.target.value);
      }
    }
  };
  return (
    <Form.Group className="text-entry">
      {props.entry.label ? 
        <Form.Label>
          {props.entry.label} 
          {props.entry.required ? <span className="custom-required">*</span> : null} 
          {props.entry.specialAsteriksVisibility && props.entry.specialAsteriksVisibility(props.stateData) ? <span className="special-asterisk"> *</span> : null}
        </Form.Label> : null
      }

      <Form.Control
        ref={inputRef}
        as={props.entry.type === 'textarea' ? 'textarea' : undefined}
        type={props.entry.type ? props.entry.type : 'text'}
        min={props.entry.type === 'number' ? props.entry.min : undefined}
        max={props.entry.type === 'number' ? props.entry.max : undefined}
        name={props.entry.mapTo}
        onChange={myChangeHandler}
        onBlur={props.entry.isPhoneNumber ? formatPhoneNumber : props.entry.isSocialSecurityNumber ? formatSocialSecurityNumber : undefined}
        required={props.entry.isRequired}
        style={props.entry.style}
        isInvalid={props.entry.isInvalid}
        rows={props.entry.rows}
        value={defaultValue}
        readOnly={props.entry.isDisabled && (typeof props.entry.isDisabled === 'function') && props.entry.isDisabled(props.stateData) }
        autoComplete={props.entry.isEmail ||  props.entry.isSocialSecurityNumber? 'off' : 'on'}
        placeholder={props.entry.isEmail ? 'email@address.com' : props.entry.isPhoneNumber ? '(xxx) xxx-xxxx' : props.entry.isSocialSecurityNumber? 'xxx-xx-xxxx' : props.entry.isInteger? '0' : props.entry.isDecimal? '0.00' : undefined}
        maxLength={props.entry.maxLength}
      />
      <Form.Control.Feedback type="invalid">
        {props.entry.isValid}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

const mapStateToProps = function(state) {
  return {
    stateData : state.pagesData.data.basicInformation
  };
};

export default connect(mapStateToProps)(TextEntry);
